import { IResponse } from "models";

export enum ActionType {
  USER_LIST_BUSINESS = "action/USER_LIST_BUSINESS",
  USER_LIST_BUSINESS_SUCCESS = "action/USER_LIST_BUSINESS_SUCCESS",
  USER_LIST_BUSINESS_ERROR = "action/USER_LIST_BUSINESS_ERROR",
  USER_LIST_BUSINESS_RESET_DATA = "action/USER_LIST_BUSINESS_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface UserListBusinessPayload {
  page: number;
  search?: string | null;
  c_department_id?: any;
  per_page: number;
  status?: number;
  locale?: string;
}

export interface UserListBusinessResponse extends IResponse {
  result?: UserListBusinessResultData[];
  total_record: number;
  current_page: number;
  next_page: number;
}

export interface UserListBusinessResultData {
  id: number;
  first_name: string;
  last_name: string;
  status: number;
  application_status: string;
  designation: string;
  free_comment: string;
  uniq_code: string;
  kojin_number: string;
  gender: string;
  day_left: number;
  date_of_birth: string;
  c_department_id: number;
}
